export default {
  'header.title': '«37 практик Бодхисаттв»'
}



// WEBPACK FOOTER //
// ./src/intl/en.js